import React,{useEffect, useState} from 'react';
import { PDFViewer } from '@progress/kendo-react-pdf-viewer';
import '@progress/kendo-theme-default/dist/all.css'; // Kendo Theme

function PdfRenderer({pdfStream, fileName}) {
  const tools=['pager', 'spacer', 'zoomInOut', 'zoom', 'selection', 'spacer', 'search', 'download', 'print']
    return (
        <PDFViewer 
          data={pdfStream}
          saveFileName={fileName}
          tools={tools}
          //url={'https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf'} 
          style={{
          height: 1200
          }}
        />
    );
}

export default PdfRenderer;